module.exports = __webpack_public_path__ + "img/b765c17007ecf968e3024dc72dc881ad.png";